import { AllowedReducer } from '@leverege/api-redux';
import { GlobalState } from '@leverege/ui-redux';
import AbstractFotaItemDelegate from "../AbstractFotaItemDelegate.js";
export default class FirmwareReleaseItemDelegate extends AbstractFotaItemDelegate {
  getApi() {
    return this.api.firmwareRelease();
  }
  pause() {
    return this.getApi().pause(this.id);
  }
  resume() {
    return this.getApi().resume(this.id);
  }
  stop() {
    return this.getApi().stop(this.id);
  }
  requestCanPause() {
    return this.getApi().canPause(this.id);
  }
  requestCanResume() {
    return this.getApi().canResume(this.id);
  }
  requestCanStop() {
    return this.getApi().canStop(this.id);
  }
  canPause(state = GlobalState.get()) {
    return AllowedReducer.get(state, this.getResourceId())?.pause;
  }
  canResume(state = GlobalState.get()) {
    return AllowedReducer.get(state, this.getResourceId())?.resume;
  }
  canStop(state = GlobalState.get()) {
    return AllowedReducer.get(state, this.getResourceId())?.stop;
  }
}